/* Accessibility fix for third-party Reel/Video carousel slides.
   Prevent hidden carousel cells from containing keyboard-focusable descendants. */
(function () {
  'use strict';

  var slideSelector = '.rf-video-item[aria-hidden="true"]';
  var focusableSelector = [
    'a[href]', 'area[href]', 'button', 'input', 'select', 'textarea',
    'summary', 'iframe', 'object', 'embed', 'video[controls]', 'audio[controls]',
    '[contenteditable="true"]', '[role="button"]', '[role="link"]', '[tabindex]'
  ].join(',');

  function disableFocus(element) {
    if (!element.hasAttribute('data-rf-a11y-tabindex')) {
      var current = element.getAttribute('tabindex');
      element.setAttribute('data-rf-a11y-tabindex', current === null ? '__none__' : current);
    }
    if (element.getAttribute('tabindex') !== '-1') element.setAttribute('tabindex', '-1');
  }

  function restoreFocus(element) {
    if (!element.hasAttribute('data-rf-a11y-tabindex')) return;
    var previous = element.getAttribute('data-rf-a11y-tabindex');
    if (previous === '__none__') element.removeAttribute('tabindex');
    else element.setAttribute('tabindex', previous);
    element.removeAttribute('data-rf-a11y-tabindex');
  }

  function syncSlide(slide) {
    if (!(slide instanceof Element) || !slide.matches('.rf-video-item')) return;
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    if (hidden) {
      slide.setAttribute('inert', '');
      slide.querySelectorAll(focusableSelector).forEach(disableFocus);
    } else {
      slide.removeAttribute('inert');
      slide.querySelectorAll('[data-rf-a11y-tabindex]').forEach(restoreFocus);
    }
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    if (root instanceof Element && root.matches('.rf-video-item')) syncSlide(root);
    root.querySelectorAll('.rf-video-item').forEach(syncSlide);
  }

  function init() {
    scan(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (target) {
          var slide = target.matches('.rf-video-item') ? target : target.closest('.rf-video-item');
          if (slide) syncSlide(slide);
        }
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) scan(node);
        });
      });
    });
    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-hidden', 'tabindex', 'controls', 'href']
    });

    // Some carousel apps rewrite focus attributes after their own animations.
    var checks = 0;
    var timer = window.setInterval(function () {
      document.querySelectorAll('.rf-video-item').forEach(syncSlide);
      checks += 1;
      if (checks >= 80) window.clearInterval(timer);
    }, 250);

    document.addEventListener('focusin', function (event) {
      var hiddenSlide = event.target && event.target.closest ? event.target.closest(slideSelector) : null;
      if (hiddenSlide) {
        syncSlide(hiddenSlide);
        event.target.blur();
      }
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
